import React, {
  Component
} from 'react';
import {connect} from "react-redux";
import {fetchProjects} from "../middleware/projectsActions";
import {updateProjectsFilter} from '../actions/projects'
import ProjectsList from "../components/ProjectsList";
import {CustomDispatchProps} from "../types/Types";
import {State} from "../reducers";
import {ProjectDataItem} from "../types/StudioAPITypes";

export interface ProjectsContainerProps extends CustomDispatchProps {
  projects: ProjectDataItem[];
  filter: string;
  updateProjectsFilter: (e: any) => void;
}

class ProjectsContainer extends Component<ProjectsContainerProps, {}> {
  componentDidMount() {
    this.props.dispatch(fetchProjects())
  }

  render() {
    return (
      <ProjectsList
        projects={this.props.projects}
        filter={this.props.filter}
        updateProjectsFilter={ (e: any) => {
          if (e.target) {
            this.props.dispatch(updateProjectsFilter(e.target.value || ""))
          }
        }}
      />
    )
  }
}

const mapStateToProps = (state: State) => ({
  projects: state.projects.items,
  filter: state.projects.filter
});

export default connect(mapStateToProps)(ProjectsContainer);
